export default __webpack_public_path__ + "271a62ec58b2d48af066c7700bdf3ead.png";